export const enSentMail = {
  //text
  SC51heading1: 'We have sent you an email from "support@yelloop.jp".',
  SC51heading2: 'Please reset your password from the URL in the email.',
}
